import React, {useContext, useState} from 'react';
import Content from './Content';
import Filters from './Filters';
import {FilterContext, filterDataType, initialValues} from './common/context/filterContext';
import {UserContext} from './common/context/userContext';
import '../assests/css/landing.scss';

export default function Landing() {

    const {filterData, setFilterContent,
        filterContent} = useContext(FilterContext);

    const {data} = useContext(UserContext);
    const [showWholesalers, setShowWholesalers] = useState(false);
    const [existingFilter, setExistingFilter] = useState<filterDataType>(
        {...initialValues}
    );

    const handleWholesalersSelect = (selected: boolean) => {
        setShowWholesalers(selected);
        if (selected === true) {
            setExistingFilter(filterContent);
            setFilterContent({
                ...initialValues,
                wholesaler: filterData.wholesaler,
            });
        } else {
            setFilterContent({...existingFilter});
        }
    }

    return (
        data.active?
        <>
            <Filters wholesalaerSelected={showWholesalers}/>
            <Content
                showWholesalers={showWholesalers}
                onWholesalersSelect={(selected)=>
                    handleWholesalersSelect(selected)}/>
        </>: null
    );

}